/* ===========================================================================
   MM — SÉLECTEUR DE CATÉGORIES
   ---------------------------------------------------------------------------
   Composant autonome. Il ne sait rien de ce qu'il filtre : il relie un socle
   à une collection par un identifiant, et lit sur chaque élément le texte à
   comparer.

     <div data-filtres data-filtres-for="projets"> … </div>
     <div data-filtres-group="projets">
       <a data-filter-tags="design · retail"> … </a>
     </div>

   Ce qu'il fait, et rien d'autre :
     · déplace le point sous la catégorie active ;
     · masque les éléments qui ne correspondent pas, et fait GLISSER ceux qui
       restent au lieu de les laisser sauter (technique FLIP) ;
     · reflète l'état dans l'URL, pour qu'une vue filtrée soit partageable ;
     · s'efface quand la fin de la collection est passée au-dessus de lui.

   Ce qu'il ne fait pas : décider de quoi a l'air un élément écarté. Il pose
   la classe .is-out, l'hôte l'habille — c'est la carte projet qui sait qu'elle
   part vers le bas en s'effaçant, pas le socle.
   =========================================================================== */

(function () {
	'use strict';

	var FADE = 200;   /* effacement des écartés, avant de les retirer du flux */
	var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

	function init() {
		Array.prototype.forEach.call(document.querySelectorAll('[data-filtres]'), function (bar) {
			if (bar.dataset.mmFiltresReady === '1') return;
			bar.dataset.mmFiltresReady = '1';
			bind(bar);
		});
	}

	function bind(bar) {
		var id = bar.getAttribute('data-filtres-for') || 'default';
		var group = document.querySelector('[data-filtres-group="' + id + '"]');
		if (!group) return;

		var items = Array.prototype.slice.call(group.querySelectorAll('[data-filter-tags]'));
		var buttons = Array.prototype.slice.call(bar.querySelectorAll('[data-filter]'));
		var dot = bar.querySelector('[data-filtres-dot]');
		var annonce = bar.querySelector('[data-filtres-annonce]');
		if (!items.length || !buttons.length) return;

		/* Chaque filtre existe en deux exemplaires : le bouton du socle
		   desktop (.mm-filtres__btn) et son jumeau dans la feuille mobile
		   (.mm-filtres__opt). Tout se synchronise par la VALEUR du filtre,
		   jamais par l'élément — sinon activer un jumeau éteindrait l'autre. */
		function keyOf(button) {
			return button.getAttribute('data-filter') || '';
		}
		function desktopBtn(key) {
			return buttons.filter(function (b) {
				return b.classList.contains('mm-filtres__btn') && keyOf(b) === key;
			})[0] || null;
		}

		/* ---------- Point actif ---------- */

		function moveDot(button) {
			if (!dot) return;
			var barBox = bar.getBoundingClientRect();
			var box = button.getBoundingClientRect();
			/* Mesuré, pas calculé d'après les libellés : la largeur d'un mot
			   dépend de la police, qui arrive après le premier rendu. */
			var size = dot.offsetWidth || 3;
			var x = (box.left - barBox.left) + (box.width / 2) - (size / 2) + bar.scrollLeft;
			dot.style.setProperty('--x', Math.round(x) + 'px');
			bar.classList.add('is-ready');
		}

		/* ---------- Filtrage ---------- */

		function matches(item, key) {
			if (!key) return true;
			var hay = (item.getAttribute('data-filter-tags') || '').toLowerCase();
			/* Des tags qui portent le séparateur « · » demandent la
			   correspondance EXACTE par jeton : la sous-chaîne confond les
			   catégories imbriquées : « commune » matchait « peu commune » sur
			   la collection de cartes. Sans séparateur, rien ne change pour
			   les hôtes existants : sous-chaîne, comme toujours. */
			if (hay.indexOf('·') !== -1) {
				return hay.split('·').some(function (t) { return t.trim() === key; });
			}
			return hay.indexOf(key) !== -1;
		}

		function apply(key, button) {
			buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(keyOf(b) === key)); });
			var twin = desktopBtn(key) || button;
			moveDot(twin);
			var label = twin.textContent.trim();
			valueLabels.forEach(function (node) { node.textContent = label; });
			sheetClose();

			var keep = items.filter(function (i) { return matches(i, key); });
			var drop = items.filter(function (i) { return !matches(i, key); });

			group.classList.toggle('is-empty', keep.length === 0);
			var host = group.closest('[data-listing]') || group;
			host.classList.toggle('is-empty', keep.length === 0);

			/* Annoncé ICI, avant l'animation FLIP : la branche
			   prefers-reduced-motion sort plus bas et sauterait l'annonce. Le
			   résultat ne dépend pas de la fin des transitions. WCAG 4.1.3. */
			/* Collection masquée par l'hôte : il montre autre chose, c'est à
			   lui d'annoncer (le compte d'ici serait faux). */
			if (annonce && group.getClientRects().length) {
				annonce.textContent = keep.length === 0
					? 'Aucun résultat pour ' + label + '.'
					: keep.length + ' résultat' + (keep.length > 1 ? 's' : '') + ' pour ' + label + '.';
			}

			if (reduce.matches) {
				drop.forEach(function (i) { i.style.display = 'none'; i.classList.add('is-out'); });
				keep.forEach(function (i) { i.style.display = ''; i.classList.remove('is-out'); });
				requestAnimationFrame(function () {
					updateAway();
					nudge();
				});
				return;
			}

			/* Étape 1 : les écartés s'effacent, en place. */
			drop.forEach(function (i) { i.classList.add('is-out'); });

			setTimeout(function () {
				/* Étape 2 : FLIP. On relève la position des survivants AVANT de
				   retirer les autres du flux, puis on les replace à leur ancienne
				   position et on les laisse glisser vers la nouvelle. Sans ça, la
				   grille se recompose d'un coup. */
				/* Les REVENANTS — masqués par le filtre précédent — n'ont pas
				   d'ancienne position : leur rect vaut zéro tant qu'ils sont en
				   display:none, et le FLIP les faisait partir du coin de la page
				   (ou surgir sans transition quand l'hôte n'anime pas transform).
				   Ils ne glissent pas : ils ENTRENT. Le moteur pose .is-in comme
				   il pose .is-out, et l'hôte habille l'arrivée. */
				var revenants = keep.filter(function (i) { return i.style.display === 'none'; });
				var before = keep.map(function (i) { return i.getBoundingClientRect(); });

				drop.forEach(function (i) { i.style.display = 'none'; });
				keep.forEach(function (i) {
					i.style.display = '';
					i.classList.remove('is-out');
				});
				revenants.forEach(function (i, n) {
					/* Le rang alimente les cascades des hôtes (délai sur var(--i)) :
					   les entrées se suivent comme la révélation du listing. */
					i.style.setProperty('--i', n);
					i.classList.add('is-in');
				});

				var after = keep.map(function (i) { return i.getBoundingClientRect(); });

				keep.forEach(function (i, n) {
					if (revenants.indexOf(i) !== -1) return; /* une entrée n'est pas un déplacement */
					var dx = before[n].left - after[n].left;
					var dy = before[n].top - after[n].top;
					if (!dx && !dy) return;
					i.style.transition = 'none';
					i.style.transform = 'translate(' + dx + 'px, ' + dy + 'px)';
				});

				/* Reflow forcé : il valide la position inverse. Remettre la
				   valeur finale dans la même tâche anime depuis elle — sans ça
				   le navigateur regroupe la pose et le retrait et il n'y a plus
				   rien à animer.

				   Pas de requestAnimationFrame ici, volontairement. La frame
				   d'animation n'est pas garantie : dans un onglet qui ne peint
				   pas, elle n'arrive jamais, et les transformations inverses
				   restaient posées — la grille se retrouvait décalée de
				   plusieurs centaines de pixels, en dur, dans l'attribut style.
				   Constaté sur banc. */
				void group.offsetHeight;

				keep.forEach(function (i) {
					i.style.transition = '';
					i.style.transform = '';
				});
				/* Après le reflow forcé : l'état de départ de .is-in est peint,
				   son retrait dans la même tâche anime l'arrivée. */
				revenants.forEach(function (i) { i.classList.remove('is-in'); });
				updateAway();
				nudge();
			}, FADE);
		}

		/* Filtrer recompose la grille sans que la fenêtre bouge : tout ce que
		   l'hôte cale sur la position du contenu — la révélation des cartes du
		   listing projets, la pause des vidéos hors écran — ne se recalcule que
		   sur scroll/resize et ne voit rien. Une carte jamais entrée dans
		   l'écran qui remonte au-dessus du pli restait en is-pending, opacité
		   zéro, jusqu'au premier défilement — constaté sur mobile, où le tap ne
		   fait pas défiler. On émet le signal que tous ces comportements
		   écoutent déjà, sans rien savoir d'eux. */
		function nudge() {
			/* Deux émissions : les écouteurs de l'hôte portent une garde
			   temporelle (100ms côté listing) et jettent les événements trop
			   rapprochés — si un vrai scroll vient de passer, la première
			   émission serait avalée. La seconde part après la fenêtre. */
			try {
				window.dispatchEvent(new Event('scroll'));
				setTimeout(function () {
					window.dispatchEvent(new Event('scroll'));
				}, 180);
			} catch (error) { /* Event indisponible : le prochain vrai scroll recalera tout */ }
		}

		/* ---------- Feuille mobile ----------
		   La mécanique de la feuille de langue du header : un déclencheur, un
		   calque avec scrim, un panneau. Ici pas de formulaire — choisir une
		   option filtre en place et referme (apply appelle sheetClose). */

		/* Deux porteurs : la valeur de la barre et son écho dans la tête du
		   panneau — le coin droit qui se morphe doit partir du même texte. */
		var valueLabels = Array.prototype.slice.call(bar.querySelectorAll('[data-filtres-value]'));
		var trigger = bar.querySelector('[data-filtres-open]');
		var sheet = bar.querySelector('[data-filtres-sheet]');
		var panel = sheet ? sheet.querySelector('.mm-filtres__panel') : null;

		function sheetIsOpen() {
			return bar.classList.contains('is-open');
		}

		/* L'ouverture est une CROISSANCE, pas un glissement : le panneau part
		   de la hauteur de la barre — posé exactement sur elle, même verre,
		   même filet, même padding, son titre sur le libellé — et grandit
		   jusqu'à sa hauteur naturelle. height:auto ne s'anime pas, donc la
		   hauteur est menée au pixel ici et la transition vit dans le CSS.
		   Une fois posé, le style repasse en auto : si la police arrive après
		   coup, le panneau suit. */

		var OPEN_MS = 500;   /* durées des transitions height, mm-filtres.css */
		var CLOSE_MS = 420;
		var sheetTimer = null;
		var BAR_H = 42;      /* secours si la barre n'est pas mesurable */

		function sheetOpen() {
			if (sheetIsOpen()) return;
			if (sheetTimer) { clearTimeout(sheetTimer); sheetTimer = null; }
			bar.classList.remove('is-closing');
			bar.classList.add('is-open');
			if (trigger) trigger.setAttribute('aria-expanded', 'true');
			/* La cible se mesure AVANT de poser le départ. L'inverse — départ
			   posé, puis mesure en passant par height:auto — intercale un
			   reflow en pleine hauteur : c'est cette valeur que le navigateur
			   retient comme état de départ, l'arrivée est identique, et il n'y
			   a plus rien à animer. L'ouverture restait sèche quand la
			   fermeture, sans mesure intermédiaire, s'animait. Constaté sur
			   banc. Rien ne se peint entre ces lignes : l'aller-retour de
			   mesure est invisible. */
			panel.style.height = '';
			var target = panel.offsetHeight;   /* hauteur auto, plafonnée par le max-height CSS */
			var from = (trigger && trigger.offsetHeight) || BAR_H;
			panel.style.height = from + 'px';
			void panel.offsetHeight;           /* latch du départ */
			panel.style.height = target + 'px';
			sheetTimer = setTimeout(function () {
				panel.style.height = '';
				sheetTimer = null;
			}, OPEN_MS);
			var current = panel.querySelector('.mm-filtres__opt[aria-pressed="true"]') || panel.querySelector('.mm-filtres__opt');
			if (current) {
				/* preventScroll : un focus qui défile ferait sauter le contenu
				   dans le bloc rogné en pleine croissance. */
				try { current.focus({ preventScroll: true }); } catch (error) { current.focus(); }
			}
		}

		function sheetClose(silent) {
			if (!sheetIsOpen() || bar.classList.contains('is-closing')) return;
			if (sheetTimer) { clearTimeout(sheetTimer); sheetTimer = null; }
			/* De la hauteur du moment vers celle de la barre. is-open reste
			   posé pendant la redescente — c'est lui qui tient le calque
			   visible — et is-closing efface contenu et scrim. */
			panel.style.height = panel.offsetHeight + 'px';
			void panel.offsetHeight;
			bar.classList.add('is-closing');
			panel.style.height = ((trigger && trigger.offsetHeight) || BAR_H) + 'px';
			if (trigger) trigger.setAttribute('aria-expanded', 'false');
			/* Marge sur la durée CSS : si le repli est démonté une frame trop
			   tôt, le panneau disparaît encore un peu plus haut que la barre
			   et le haut du bloc saute. La barre est déjà revenue sous le
			   verre à ce moment-là, ces quelques frames sont stables. */
			sheetTimer = setTimeout(function () {
				bar.classList.remove('is-open', 'is-closing');
				panel.style.height = '';
				sheetTimer = null;
				if (trigger && !silent) trigger.focus();
			}, CLOSE_MS + 60);
		}

		if (trigger && panel) {
			trigger.addEventListener('click', function () {
				if (sheetIsOpen()) sheetClose(); else sheetOpen();
			});

			Array.prototype.forEach.call(sheet.querySelectorAll('[data-filtres-close]'), function (node) {
				node.addEventListener('click', function () { sheetClose(); });
			});

			/* Le panneau se déclare aria-modal : la tabulation y reste
			   enfermée, et Échap referme — même contrat que la feuille de
			   langue du header. */
			panel.addEventListener('keydown', function (event) {
				if (event.key === 'Escape') {
					sheetClose();
					return;
				}
				if (event.key !== 'Tab') return;
				var focusables = panel.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])');
				if (!focusables.length) return;
				var first = focusables[0];
				var last = focusables[focusables.length - 1];
				if (event.shiftKey && document.activeElement === first) {
					event.preventDefault();
					last.focus();
				} else if (!event.shiftKey && document.activeElement === last) {
					event.preventDefault();
					first.focus();
				}
			});
		}

		buttons.forEach(function (button) {
			button.addEventListener('click', function () {
				var key = button.getAttribute('data-filter') || '';
				apply(key, button);
				/* replaceState et non pushState : filtrer n'est pas une
				   navigation, le bouton retour doit ramener à la page d'avant. */
				try {
					var url = new URL(window.location.href);
					if (key) url.searchParams.set('filtre', key);
					else url.searchParams.delete('filtre');
					window.history.replaceState(null, '', url);
				} catch (error) { /* URL indisponible : le filtrage marche quand même */ }
			});
		});

		/* ---------- Effacement en fin de collection ----------
		   Le socle s'en va quand le bas de la collection est passé au-dessus de
		   sa ligne de repos. Cette ligne est calculée depuis son propre CSS —
		   pas un seuil de scroll en dur — et depuis sa hauteur hors transform,
		   sinon l'escamotage déplacerait la ligne et le socle clignoterait. */

		function restingTop() {
			var offset = parseFloat(getComputedStyle(bar).bottom);
			if (isNaN(offset)) offset = 0;
			return window.innerHeight - offset - bar.offsetHeight;
		}

		function updateAway() {
			/* Feuille ouverte : le socle ne s'escamote pas. L'escamotage pose
			   un transform sur le conteneur, qui deviendrait alors le bloc
			   conteneur du calque fixed — la feuille décrocherait de la
			   fenêtre en plein choix. */
			if (sheetIsOpen()) {
				bar.classList.remove('is-away');
				return;
			}
			/* Collection masquée par l'hôte (la vue deck de la collection de
			   cartes) : on mesure son parent, qui porte ce qui est montré à la
			   place. Mesurée telle quelle, une collection masquée a une boîte
			   nulle et le socle restait par-dessus le pied de page. */
			var zone = (group.offsetParent === null && group.parentElement) ? group.parentElement : group;
			var box = zone.getBoundingClientRect();
			var line = restingTop();
			/* Deux cas d'effacement : la collection est déjà passée au-dessus du
			   socle (on est arrivé au pied de page), ou elle n'est pas encore
			   entrée dans l'écran. Entre les deux, le socle est là. */
			/* Le haut aussi doit être sorti : sur une grille plus courte que
			   l'écran (un filtre qui ne laisse qu'une rangée), le bas est sous
			   la ligne dès le chargement, et le socle disparaissait sans jamais
			   revenir, plus aucun moyen de revenir à « Toutes ». */
			var passee = box.bottom < line && box.top < 0;
			var pasEncore = box.top > window.innerHeight;
			bar.classList.toggle('is-away', passee || pasEncore);
		}

		/* Garde temporelle et non requestAnimationFrame : la frame d'animation
		   n'est pas garantie, et si elle n'arrive pas le drapeau reste levé et
		   l'effacement ne se recalcule plus jamais. Même raison que dans
		   assets/mm-projets-listing.js. */
		var last = 0;
		function onScroll() {
			var now = Date.now();
			if (now - last < 80) return;
			last = now;
			updateAway();
		}
		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', function () {
			onScroll();
			/* Les jumeaux mobiles sont actifs eux aussi : on recale le point
			   sur le bouton du socle, le seul qui se mesure. */
			var active = buttons.filter(function (b) {
				return b.classList.contains('mm-filtres__btn') && b.getAttribute('aria-pressed') === 'true';
			})[0];
			if (active) moveDot(active);
		});

		/* ---------- État initial ---------- */

		var initial = null;
		try {
			var wanted = new URL(window.location.href).searchParams.get('filtre');
			if (wanted) {
				initial = buttons.filter(function (b) {
					return (b.getAttribute('data-filter') || '') === wanted.toLowerCase();
				})[0] || null;
			}
		} catch (error) { initial = null; }

		if (initial) apply(initial.getAttribute('data-filter'), initial);
		else moveDot(buttons[0]);

		updateAway();

		/* La police custom arrive après le premier rendu et décale les
		   libellés : on recale le point une fois qu'elle est posée. */
		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(function () {
				var active = buttons.filter(function (b) {
					return b.classList.contains('mm-filtres__btn') && b.getAttribute('aria-pressed') === 'true';
				})[0];
				if (active) moveDot(active);
			});
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
	document.addEventListener('shopify:section:load', init);
})();
